import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { ROUTES, DECLARE_COMPONENTS, DECLARE_SERVICES } from './app.routes';
import { DropdownModule, ModalModule,TypeaheadModule,TooltipModule, AccordionModule, TabsModule, PaginationModule } from 'ng2-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { AgmCoreModule } from 'angular2-google-maps/core';
import { UrlSerializer} from '@angular/router';
import { CustomUrlSerializer} from './CustomUrlSerializer';
import { CoreModule } from './core.module';
import { NgxGalleryModule } from 'ngx-gallery';
import { NgProgressModule } from 'ngx-progressbar';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ProgressInterceptor } from './shared/interceptor/progress-interceptor';
import { CommonModalModule } from './shared/common-modal/common-modal.module';
import { AuthInterceptor } from './shared/interceptor/auth-interceptor';
import { AuthService } from './services/auth.service';

export function initAppConfig(authService: AuthService): () => Promise<any> {
  return () => authService.loadSystemConfig();
}

@NgModule({
  declarations: [
    AppComponent,
	...DECLARE_COMPONENTS,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    CoreModule.forRoot(),
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyC4YE0C9HRGEKfrU5BgRDOeLdXG4Rq1s18', libraries: ["places"] }),
    // AgmCoreModule.forRoot({ apiKey: 'AIzaSyABbQ_bxq1HEwhbOUOGUkeMBHBvbljT5eQ', libraries: ["places"] }),
    FileUploadModule,
    NgxGalleryModule,
    DropdownModule.forRoot(),
    ModalModule.forRoot(),
    TypeaheadModule.forRoot(),
    TooltipModule.forRoot(),
    AccordionModule.forRoot(),
    RouterModule.forRoot(ROUTES, {useHash: true}),
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    NgProgressModule,
    CommonModalModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER, useFactory: initAppConfig,
      multi: true,
      deps: [AuthService]
    },
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    { provide: HTTP_INTERCEPTORS, useClass: ProgressInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ...DECLARE_SERVICES
   ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/app.module.ts